export class FacultyModel{
Id:string;
FacultyCode:string;
Name:string;
FacultyFellowshipSpecialtiesCount:number;
FacultyMedicalProcedureCategoryCount:number;
FacultyMedicalProceduresCount:number;
FacultyContinuousAssessmentFormCount:number;
  mFacult: FacultyModel[];
}